interface ReviewItem {
  name: string;
  location: string;
  rating: number;
  content: string;
  avatar: string;
}

interface ReviewsSectionProps {
  sectionTitle: string;
  sectionSubtitle: string;
  items: ReviewItem[];
}

function StarRating({ rating }: { rating: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: 5 }, (_, i) => (
        <i
          key={i}
          className={`text-sm ${i < rating ? "ri-star-fill text-primary-500" : "ri-star-line text-secondary-300"}`}
        ></i>
      ))}
    </div>
  );
}

export default function ReviewsSection({ sectionTitle, sectionSubtitle, items }: ReviewsSectionProps) {
  return (
    <section id="reviews" className="py-16 md:py-20 bg-background-50">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-900 mb-3">
            {sectionTitle}
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            {sectionSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {items.map((item, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-lg p-6 md:p-7 flex flex-col cursor-default"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-11 h-11 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={item.avatar}
                    alt={item.name}
                    title={`${item.name} - 爱威奶用户`}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div>
                  <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                  <p className="text-xs text-foreground-500">{item.location}</p>
                </div>
              </div>
              <StarRating rating={item.rating} />
              <p className="mt-3 text-sm text-foreground-700 leading-relaxed flex-1">
                &ldquo;{item.content}&rdquo;
              </p>
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <div className="inline-flex items-center gap-6 text-sm text-foreground-500">
            <div className="text-center">
              <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600">100万+</p>
              <p className="text-xs mt-1">服务家庭</p>
            </div>
            <div className="w-px h-10 bg-background-300"></div>
            <div className="text-center">
              <p className="font-heading text-2xl md:text-3xl font-bold text-accent-600">98.6%</p>
              <p className="text-xs mt-1">用户满意度</p>
            </div>
            <div className="w-px h-10 bg-background-300"></div>
            <div className="text-center">
              <p className="font-heading text-2xl md:text-3xl font-bold text-primary-600">200+</p>
              <p className="text-xs mt-1">覆盖城市</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}